// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"06e83de7","33":"5c9d684e","60":"67d67421","144":"482681d1","205":"c08809de","270":"379ca989","337":"417f432e","453":"7df676fc","527":"cd296254","595":"90d96748","616":"a9577544","647":"2e926f99","712":"53fc5ae0","723":"a2cbf2bd","827":"37cf80a5","882":"b9c7d5fd"}[chunkId] + ".chunk.js";
};